<template>
  <div class="row">
    <div class="col" v-if="!overlay">

      <div class="text-center" v-if="user_address.length">
        <div class="flex-center">
          <v-radio-group
            v-model="new_address"
            row
          >
            <v-radio
              label="Dirección existente"
              :value="false"
            ></v-radio>
            <v-radio
              label="Nueva dirección"
              :value="true"
            ></v-radio>
          </v-radio-group>
        </div>

        <!--dropdown para seleccionar direccion-->
        <v-menu offset-y v-if="!new_address">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              color="accent"
              v-bind="attrs"
              v-on="on"
            >
              {{ address_selected ? address_selected.full_address : 'ELIGE UNA DIRECCIÓN'}}
              <v-icon color="primary">mdi-menu-swap</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in user_address"
              :key="index"
              @click="validateAddressExists(item)"
            >
              <v-list-item-title>{{ item.full_address }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <google-places-autocomplete
        v-if="new_address"
        @resultChanged="placeDetail => getAddressData(placeDetail)"
      >
        <div slot="input" slot-scope="{ context, events, actions }">
          <input
            v-model="context.input"
            @focus="events.inputHasReceivedFocus"
            @input="events.inputHasChanged"
            @keydown.enter.prevent="actions.selectItemFromList"
            @keydown.down.prevent="actions.shiftResultsSelection"
            @keydown.up.prevent="actions.unshiftResultsSelection"
            type="search"
            id="locationInput"
            placeholder="Ingresa tu dirección completa"
            class="input-nv"
          />
          <div class="text-right mt-1">
            <img
              class="powered_by_google"
              src="@/assets/store/powered_by_google.png"
              alt="powered by google"
            >
          </div>
        </div>
      </google-places-autocomplete>

      <div class="mt-5" v-if="address.latitude && address.longitude && valid_address">
        <form data-vv-scope="form-address">
          <label class="label-nv" for="name">DIRECCIÓN DE ENVÍO</label>
          <div class="row mb-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="name">Nombre *</label><br>
                <input v-model="address.name" name="name" v-validate="new_address ? 'required' : ''" data-vv-as="Nombre" class="input-nv" id="name">
                <br>
                <span v-show="errors.has('form-address.name')" class="text-danger mt-2">
                  {{ errors.first("form-address.name") }}
                </span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="lastname">Apellido *</label><br>
                <input v-model="address.lastname" name="lastname" v-validate="new_address ? 'required' : ''" data-vv-as="Apellido" class="input-nv" id="lastname">
                <br>
                <span v-show="errors.has('form-address.lastname')" class="text-danger mt-2">
                  {{ errors.first("form-address.lastname") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="street">Calle *</label><br>
                <input
                  :disabled="fields_disabled.street"
                  v-model="address.street"
                  name="street"
                  v-validate="new_address ? 'required' : ''"
                  data-vv-as="Calle"
                  class="input-nv"
                  id="street"
                >
                <br>
                <span v-show="errors.has('form-address.street')" class="text-danger mt-2">
                  {{ errors.first("form-address.street") }}
                </span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="ext">No. exterior *</label><br>
                <input
                  :disabled="fields_disabled.no_outside"
                  v-model="address.no_outside"
                  name="no_exterior"
                  v-validate="new_address ? 'required' : ''"
                  data-vv-as="No. exterior"
                  class="input-nv"
                  id="ext"
                >
                <br>
                <span v-show="errors.has('form-address.no_exterior')" class="text-danger mt-2">
                  {{ errors.first("form-address.no_exterior") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="int">No. interior *</label>
                <input
                  v-model="address.no_inside"
                  name="no_inside"
                  v-validate="new_address ? 'required' : ''"
                  data-vv-as="No. interior"
                  class="input-nv"
                  id="int"
                >
                <br>
                <span v-show="errors.has('form-address.no_inside')" class="text-danger mt-2">
                  {{ errors.first("form-address.no_inside") }}
                </span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="colony">Colonia *</label><br>
                <input
                  :disabled="fields_disabled.colony"
                  v-model="address.colony"
                  name="colony"
                  v-validate="new_address ? 'required' : ''"
                  data-vv-as="Colonia"
                  class="input-nv"
                  id="colony"
                >
                <br>
                <span v-show="errors.has('form-address.colony')" class="text-danger mt-2">
                  {{ errors.first("form-address.colony") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="zip">* Código Postal</label>
                <input
                  :disabled="fields_disabled.zip"
                  name="zip"
                  v-validate="new_address ? 'required' : ''"
                  data-vv-as="Código postal"
                  v-model="address.zip"
                  class="input-nv"
                  id="zip"
                >
                <br>
                <span v-show="errors.has('form-address.zip')" class="text-danger mt-2">
                  {{ errors.first("form-address.zip") }}
                </span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="city">Ciudad *</label><br>
                <input
                  :disabled="fields_disabled.city"
                  v-model="address.city"
                  name="city"
                  v-validate="new_address ? 'required' : ''"
                  data-vv-as="Ciudad"
                  class="input-nv"
                  id="city"
                >
                <br>
                <span v-show="errors.has('form-address.city')" class="text-danger mt-2">
                  {{ errors.first("form-address.city") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group text-center">
                <label class="label-nv" for="phone">Teléfono *</label>
                <input
                  v-model="address.phone"
                  name="phone"
                  v-validate="'required|numeric|digits:10'"
                  data-vv-as="Teléfono"
                  class="input-nv"
                  id="phone"
                  v-mask="mask"
                >
                <br>
                <span v-show="errors.has('form-address.phone')" class="text-danger mt-2">
                  {{ errors.first("form-address.phone") }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col text-left">
              <v-checkbox
                v-model="address.primary_address"
                label="Guardar como dirección principal"
                color="primary"
              ></v-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col text-right">
              <v-btn
                @click="saveAddress()"
                color="primary"
                class="nv-btn nv-btn-large nv-btn-hover"
                :loading="loading"
                elevation="0"
              >
                GUARDAR
              </v-btn>
            </div>
          </div>
        </form>
      </div>

    </div>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="30"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { GooglePlacesAutocomplete } from 'vue-better-google-places-autocomplete'
//import isPointInPolygon from 'geolib/es/isPointInPolygon';
import UserService from '@/services/user.service'
//import GeneralService from '@/services/general.service'

export default {
  props: ['subscription_id'],
  components: {
    GooglePlacesAutocomplete
  },
  data() {
    return {
      mask: [/\d/, /\d/, '', /\d/, /\d/, /\d/, /\d/, '', /\d/, /\d/, /\d/, /\d/],
      coords_restricted: [],
      overlay: false,
      address_selected: null,
      new_address: false,
      user_address: [],
      loading: false,
      valid_address: true,
      fields_disabled: {
        street: false,
        no_outside: false,
        colony: false,
        zip: false,
        city: false
      },

      zip: '',
      city: '',
      outside: '',
      street: '',
      colony: '',

      address: {
        contact_email: '',
        name: '',
        lastname: '',
        street: '',
        no_outside: '',
        no_inside: '',
        colony: '',
        zip: '',
        city: '',
        phone: '',
        primary_address: false,
        latitude: '',
        longitude: ''
      },
    }
  },
  watch: {
    new_address() {
      this.address = JSON.parse(JSON.stringify(this.$options.data().address))
    }
  },
  methods: {
    getAddressData(addressData) {
      console.log(addressData)
      console.log(addressData.geometry.location.lat(),addressData.geometry.location.lng())

      this.zip = ''
      this.city = ''
      this.outside = ''
      this.street = ''
      this.colony = ''

      addressData.address_components.forEach(i => {
        if (i.types.length) {
          if (i.types.indexOf('postal_code') > -1) {
            this.zip = i.long_name
          }
          if (i.types.indexOf('locality') > -1) {
            this.city = i.long_name
          }
          if (i.types.indexOf('street_number') > -1) {
            this.outside = i.long_name
          }
          if (i.types.indexOf('route') > -1) {
            this.street = i.long_name
          }
          if (i.types.indexOf('sublocality_level_1') > -1) {
            this.colony = i.long_name
          }
        }
      })
      this.address.zip = this.zip
      this.address.city = this.city
      this.address.no_outside = this.outside
      this.address.street = this.street
      this.address.colony = this.colony
      this.address.latitude = addressData.geometry.location.lat()
      this.address.longitude = addressData.geometry.location.lng()

      this.disabledFieldsForm()

      if (!this.validateAddressEntered()) {
        this.address.latitude = ''
        this.address.longitude = ''
        this.$swal(
          'La dirección ingresada no es valida, por favor ingresa tu dirección completa',
          'Considera colocar la calle, número de exterior y la colonia para una mejor búsqueda',
          'warning'
        )
        return false
      }/* else {
        this.validateLocation(addressData.geometry.location.lat(), addressData.geometry.location.lng())
      }*/
    },
    validateAddressEntered() {
      if (this.address.city == '' || this.address.street == '' || this.address.colony == '') {
        return false
      } else {
        return true
      }
    },
    disabledFieldsForm() {
      if (this.address.zip != '') {
        this.fields_disabled.zip = true
      } else {
        this.fields_disabled.zip = false
      }
      if (this.address.city != '') {
        this.fields_disabled.city = true
      } else {
        this.fields_disabled.city = false
      }
      if (this.address.no_outside != '') {
        this.fields_disabled.no_outside = true
      } else {
        this.fields_disabled.no_outside = false
      }
      if (this.address.street != '') {
        this.fields_disabled.street = true
      } else {
        this.fields_disabled.street = false
      }
      if (this.address.colony != '') {
        this.fields_disabled.colony = true
      } else {
        this.fields_disabled.colony = false
      }

      this.fields_disabled = {...this.fields_disabled}
    },
    /*
    validateLocation(lat, lng) {
      for (let index = 0; index < this.coords_restricted.length; index++) {
        if (isPointInPolygon({
          latitude: lat,
          longitude: lng
        }, this.coords_restricted[index])) {
          this.valid_address = false
          break
        } else {
          this.valid_address = true
        }
      }
      setTimeout(() => {
        if (!this.valid_address) {
          this.$swal('Lo sentimos, no estamos disponibles para la ubicación seleccionada', '', 'warning')
        }
      }, 1000)
    },*/
    saveAddress() {
      this.$validator.validateAll('form-address').then(async result => {
        if (result) {
          try {
            this.loading = true
            const { data:res } = await UserService.changeAddressSubscription({
              subscription_id: this.subscription_id,
              address: this.address,
              new_address: this.new_address
            })
            if (res.success) {
              this.$emit('addressChanged', res.data)
              this.$swal('Listo!', res.message, 'success')
            } else {
              this.$swal(res.message, '', 'warning')
            }
            this.loading = false
          } catch (error) {
            this.loading = false
            this.$swal('Ups!', 'En estos momentos no se puede procesar el cambio de dirección, intenta más tarde', 'warning')
          }
        } else {
          this.$swal(
            'Completa los datos de la dirección de envío',
            this.errors.items[0].msg,
            'warning'
          )
          return false
        }
      })
    },
    validateAddressExists(address) {
      this.address_selected = address
      this.address = address
      //this.validateLocation(this.address_selected.latitude, this.address_selected.longitude)
      this.disabledFieldsForm()
    },
    async getUserAddress() {
      this.overlay = true
      const { data:res } = await UserService.getUserAddress()
      this.user_address = res
      if (!res.length) {
        this.new_address = true
      }
      this.overlay = false
    }
  },
  mounted() {
    this.getUserAddress()
  }
}
</script>
